var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"titre-h3 mt-3 mb-3 ml-1"},[_vm._v(" Foire aux questions ")]),_c('v-card',{staticClass:"pa-5"},[_c('div',{staticClass:"mt-6"},[(_vm.serverError && !_vm.loading)?_c('BaseMessageServerError'):_vm._e(),(!_vm.loading)?_c('FaqThemes',{attrs:{"faq-themes":_vm.formattedThemes}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }